import React from 'react';
import { Archive } from 'lucide-react';

const ArchivedChatsButton = ({ 
  showingArchived, 
  setShowingArchived, 
  archivedChats 
}) => {
  if (showingArchived || archivedChats.length === 0) return null;
  
  return (
    <div className="mt-4 pt-4 border-t border-gray-200 dark:border-gray-700">
      <button
        onClick={() => setShowingArchived(true)}
        className="flex items-center text-sm theme-text-secondary hover:theme-text-primary transition-colors duration-200 p-3 rounded-lg hover:bg-gray-100 dark:hover:bg-gray-800 w-full"
      >
        <Archive size={16} className="mr-2" />
        Archived Chats ({archivedChats.length})
      </button>
    </div>
  );
};

export default ArchivedChatsButton;